import { SanityImg } from "../../../../../../lib/images.jsx";
import { styles } from "./ModuleLink.css.ts";

/**
 * Renders the title of a module along with optional images.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.title - The title to display.
 * @param {Array<string>} props.imgs - An array of image URLs to render alongside the title.
 *
 * @returns {JSX.Element} The rendered module title component.
 */
export const ModuleTitle = ({ title, imgs }) => {
  return (
    <div className={styles.moduleTitle}>
      <span className={styles.moduleTitleText}>{title}</span>
      <span className={styles.moduleImages}>
        {imgs.length > 0 && (
          <>
            {imgs.map((img, idx) => (
              <SanityImg
                key={idx}
                url={img}
                height={60}
                style={styles.moduleImage}
              />
            ))}
          </>
        )}
      </span>
    </div>
  );
};
